import AddIcon from '@mui/icons-material/Add';
import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';

import { NewPackageFamilyForm } from './new-package-family-form.js';
import { PackageStoreTable } from './package-store-table.js';

export const Route = createFileRoute('/_authorization-gate/package-store/')({
	staticData: {
		authorize: (ability) => ability.can('manage', 'package'),
		navigation: {
			label: 'Package Store',
			keywords: ['packages', 'store', 'library'],
		},
	},
	head: () => ({ meta: [{ title: 'Package Store • Cadstrom' }] }),
	component: PackageStoreHome,
});

function PackageStoreHome() {
	const [packageFamilySearchTerm, setPackageFamilySearchTerm] = useState('');
	const [isNewPackageFamilyDialogOpen, setIsNewPackageFamilyDialogOpen] = useState(false);

	const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setPackageFamilySearchTerm(event.target.value);
	};

	const handleClearSearch = () => {
		setPackageFamilySearchTerm('');
	};

	return (
		<div className='flex h-full min-h-0 grow flex-col gap-2 p-3'>
			{/* Header with search */}
			<div className='border-b border-gray-a4 pb-2'>
				<div className='flex flex-col gap-4'>
					<h1 className='text-2xl font-semibold text-gray-a12'>Package Store</h1>
					<div className='flex items-end justify-between'>
						<TextField
							autoFocus
							className='max-w-[400px] flex-1'
							size='small'
							placeholder='Search package families...'
							value={packageFamilySearchTerm}
							onChange={handleSearchChange}
							slotProps={{
								input: {
									startAdornment: (
										<InputAdornment position='start'>
											<SearchIcon fontSize='small' />
										</InputAdornment>
									),
									endAdornment: packageFamilySearchTerm && (
										<InputAdornment position='end'>
											<IconButton
												size='small'
												onClick={handleClearSearch}
												edge='end'
												aria-label='clear search'
												className='text-gray-a11'
											>
												<ClearIcon fontSize='small' />
											</IconButton>
										</InputAdornment>
									),
								},
							}}
						/>

						<Button startIcon={<AddIcon />} onClick={() => setIsNewPackageFamilyDialogOpen(true)}>
							<span>New Package Family</span>
						</Button>
					</div>
				</div>
			</div>

			{/* Package browser content */}
			<div className='flex min-h-0 grow flex-col'>
				<PackageStoreTable packageFamilySearchTerm={packageFamilySearchTerm} />
			</div>

			<Dialog open={isNewPackageFamilyDialogOpen} onClose={() => setIsNewPackageFamilyDialogOpen(false)}>
				<NewPackageFamilyForm onFinished={() => setIsNewPackageFamilyDialogOpen(false)} />
			</Dialog>
		</div>
	);
}
